import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-storage-chooser',
  templateUrl: './storage-chooser.component.html',
  styleUrls: ['./storage-chooser.component.scss']
})
export class StorageChooserComponent implements OnInit {

  @ViewChild('storageModal', { static: true }) storageModal: ModalDirective;

  constructor() { }

  ngOnInit() {
  }

  show() {
    this.storageModal.show();
  }
}
